// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popover-filtros .popover-header{color:#212529;background-color:transparent;text-align:center!important;font-family:Trebuchet MS;font-size:20px;padding:20px}.popover-filtros.popover{max-width:500px!important}.popover-filtros .popover-body{padding:20px}.popover-filtros.popover{width:500px!important;max-width:90vw!important;border-radius:8px}.popover-filtros *{box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
